import { useEffect, useState } from "react";

const defaultState = {
  whenOnline: "online",
  whenOffline: "offline",
  startOnline: true,
};

/**
 * Hook for listening to network status changes through the navigator API
 * @name useNavigatorOnline
 * @author magnus
 */
function useNavigatorOnline(state = {}) {
  const { whenOnline, whenOffline, startOnline } = { ...defaultState, ...state };
  const [value, setValue] = useState(startOnline);

  useEffect(() => {
    if (window.navigator.onLine !== value) {
      setValue(window.navigator.onLine);
      return;
    }

    function handleOnlineStatus() {
      setValue(window.navigator.onLine);
    }

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, [value, setValue]);

  const isOnline = value === true;
  const isOffline = value === false;
  const status = isOnline ? whenOnline : whenOffline;

  return { status, isOnline, isOffline };
}

export { useNavigatorOnline };
